module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterZones
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.logsTable,
      "stripe": "",
      "cell-class-name": "cellStyle"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "timeFormatted",
      "label": "Time",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "category_type_name",
      "label": "Category",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "entity_type_name",
      "label": "Entity",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "log_type_name",
      "label": "Log Type",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "type_name",
      "label": "Type",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "old_value",
      "label": "Old Value",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 150,
      "prop": "new_value",
      "label": "New Value",
      "sortable": ""
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d03f038c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ZoneLogs.vue
// module id = 1413
// module chunks = 1